export default __webpack_public_path__ + "static/media/Group 3192@2x.f4f292e9.png";